export { default as RoofingShingle } from './RoofingShingle';
